import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import BuilderSetup from "@/pages/builder/BuilderSetup";
import ProjectIntake from "@/pages/builder/ProjectIntake";
import BuilderOverview from "@/pages/builder/BuilderOverview";
import NewMail from "@/pages/builder/NewMail";
import RfiWarRoom from "@/pages/builder/RfiWarRoom";
import DecisionImport from "@/pages/builder/DecisionImport";
import StageConditions from "@/pages/builder/StageConditions";
import ProofReview from "@/pages/builder/ProofReview";
import StageReadiness from "@/pages/builder/StageReadiness";
import InspectionReadiness from "@/pages/builder/InspectionReadiness";
import TradeRelease from "@/pages/builder/TradeRelease";
import TradePass from "@/pages/builder/TradePass";
import SiteReadyPack from "@/pages/builder/SiteReadyPack";
import PreSubmissionCheck from "@/pages/builder/PreSubmissionCheck";
import JobBlockerCopilot from "@/pages/builder/JobBlockerCopilot";
import JobBlocker from "@/pages/builder/JobBlocker";
import ReleaseCalendar from "@/pages/builder/ReleaseCalendar";
import ScopeBoundaryLedger from "@/pages/builder/ScopeBoundaryLedger";
import WhatsappActionRail from "@/pages/builder/WhatsappActionRail";
import ReadinessDossier from "@/pages/builder/ReadinessDossier";
import EmailActionRail from "@/pages/builder/EmailActionRail";
import SurveyorOverview from "@/pages/surveyor/SurveyorOverview";
import IncomingPacks from "@/pages/surveyor/IncomingPacks";
import ReviewCentre from "@/pages/surveyor/ReviewCentre";
import CloseoutView from "@/pages/surveyor/CloseoutView";
import ClientPortal from "@/pages/shared/ClientPortal";
import BuyerHandover from "@/pages/shared/BuyerHandover";
import { TourProvider } from "@/components/shared/LiveDemoTour";
import { HeroFlowProvider } from "@/components/shared/HeroFlowRunner";
import { DemoStateProvider } from "@/data/demoState";
import ScenarioHub from "@/components/shared/ScenarioHub";
import { Toaster } from "sonner";

function App() {
  return (
    <BrowserRouter>
      <DemoStateProvider>
        <TourProvider>
          <HeroFlowProvider>
          <Toaster position="top-right" richColors />
          <ScenarioHub />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/builder/setup" element={<BuilderSetup />} />
            <Route path="/builder/project-intake" element={<ProjectIntake />} />
            <Route path="/builder" element={<BuilderOverview />} />
            <Route path="/builder/new-mail" element={<NewMail />} />
            <Route path="/builder/rfi-war-room" element={<RfiWarRoom />} />
            <Route path="/builder/decision-import" element={<DecisionImport />} />
            <Route path="/builder/stage-conditions" element={<StageConditions />} />
            <Route path="/builder/proof-review" element={<ProofReview />} />
            <Route path="/builder/stage-readiness" element={<StageReadiness />} />
            <Route path="/builder/inspection-readiness" element={<InspectionReadiness />} />
            <Route path="/builder/trade-release" element={<TradeRelease />} />
            <Route path="/builder/trade-pass/:tradeId" element={<TradePass />} />
            <Route path="/builder/site-ready-pack" element={<SiteReadyPack />} />
            <Route path="/builder/pre-submission-check" element={<PreSubmissionCheck />} />
            <Route path="/builder/job-blocker-copilot" element={<JobBlockerCopilot />} />
            <Route path="/builder/job-blocker" element={<JobBlocker />} />
            <Route path="/builder/release-calendar" element={<ReleaseCalendar />} />
            <Route path="/builder/scope-boundary-ledger" element={<ScopeBoundaryLedger />} />
            <Route path="/builder/whatsapp-action-rail" element={<WhatsappActionRail />} />
            <Route path="/builder/readiness-dossier" element={<ReadinessDossier />} />
            <Route path="/builder/email-action-rail" element={<EmailActionRail />} />
            <Route path="/surveyor" element={<SurveyorOverview />} />
            <Route path="/surveyor/incoming-packs" element={<IncomingPacks />} />
            <Route path="/surveyor/review-centre" element={<ReviewCentre />} />
            <Route path="/surveyor/closeout-view" element={<CloseoutView />} />
            <Route path="/shared/client-portal" element={<ClientPortal />} />
            <Route path="/shared/buyer-handover" element={<BuyerHandover />} />
          </Routes>
          </HeroFlowProvider>
        </TourProvider>
      </DemoStateProvider>
    </BrowserRouter>
  );
}

export default App;
